export const constants = {
  STORAGE_KEY_USER: "flowless:user"
};
